import { array, bool, func, object } from "prop-types";
import React, { useRef } from "react";
import { useDispatch } from "react-redux";

import api from "@api/index";

import Modal from "./Modal";
import { Button } from "./Button";

import { useTranslation } from "@lib/i18n";

import { updateCarPreconfigurationAction } from "@redux/actions/dealActions";
import { setLastChangedAtAction } from "@redux/actions/deprecatedActions";

const InvalidPreconfigurationModal = props => {
  const {
    defaultPreconfiguration,
    fallbackPreconfiguration,
    isOpen,
    onClose,
    preconfigurations,
  } = props;

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const firstElementRef = useRef(null);
  const lastElementRef = useRef(null);

  const handleNotExistingPreconfiguration = preconfiguration => {
    dispatch(updateCarPreconfigurationAction(preconfiguration));
    dispatch(setLastChangedAtAction(Date.now()));
    onClose?.();
    api.updateSession({ deepLinkErrorMessage: null });
  };

  return (
    <Modal
      ariaLabel={t("deeplinkConfigModal.errorMessage")}
      disableBackdropClick
      disableEscapePress
      firstElement={fallbackPreconfiguration ? firstElementRef : lastElementRef}
      isOpen={isOpen}
      lastElement={lastElementRef}
    >
      <div className="flex flex-col items-center h-full gap-8 py-4 text-center">
        <h4 className="text-xl font-semibold">
          {t("deeplinkConfigModal.errorMessage")}
        </h4>
        <div className="flex flex-wrap items-center justify-center gap-4 w-full">
          {fallbackPreconfiguration && (
            <Button
              data-id="popup-configmodal-default-config"
              ref={firstElementRef}
              onClick={() =>
                handleNotExistingPreconfiguration(fallbackPreconfiguration)
              }
            >
              {t("deeplinkConfigModal.defaultPreconfig")}
            </Button>
          )}
          <Button
            data-id="popup-configmodal-new-config"
            ref={lastElementRef}
            onClick={() =>
              handleNotExistingPreconfiguration(
                defaultPreconfiguration || preconfigurations[0]
              )
            }
          >
            {t("deeplinkConfigModal.resetConfig")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

InvalidPreconfigurationModal.propTypes = {
  defaultPreconfiguration: object.isRequired,
  fallbackPreconfiguration: object.isRequired,
  isOpen: bool.isRequired,
  onClose: func.isRequired,
  preconfigurations: array.isRequired,
};

export default InvalidPreconfigurationModal;
